import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataStorageService } from '../../../data-storage.service';
import { SecurityService } from '../../../security.service';
import { ApiService } from '../../../api.service';
import { AvailableComponents } from '../../../side-bar/enumAvailableComponents';
import { ApiTextService } from '../../../apiServices/text/text.service';
import {ThreeCXPricing} from '../../../../models/ThreeCXPricing';
import {SipTrunkPricing} from '../../../../models/SipTrunkPricing';
import {PricingService} from '../../../pricing.service';
import { SipTrunk } from '../../../../models/SipTrunk';


@Component({
  selector: 'app-peoplephone-siptrunk',
  templateUrl: './peoplephone-siptrunk.component.html',
  styleUrls: ['./peoplephone-siptrunk.component.scss']
})
export class PeoplephoneSiptrunkComponent implements OnInit, OnDestroy {

  pricingList: SipTrunkPricing[];
  voiceChannels: number[];
  constructor(
    public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    private tApi: ApiTextService,
    private api: ApiService,
    private pricing: PricingService
  ) {
    this.pricingList = [];
    this.voiceChannels = []
    // this.dataStorageService.currentState.sipTrunk.costMonthly = 0;
    // this.dataStorageService.currentState.sipTrunk.costUnique = 0;
    pricing.getSipTrunkPriceList().then(data => {
      this.pricingList = data;
      this.voiceChannels = this.getVoiceChannels();
    });
  }

  ngOnInit() {
    const element = document.getElementById('pfSIPTRUNK');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['PeoplephoneSIPTRUNK'];
  }

  ngOnDestroy() {
    const element = document.getElementById('pfSIPTRUNK');
    element.classList.remove('active');
  }

  updateText(event, key: string) {
    const value = event.target.value;
    this.tApi.putUIText(key, value);
    this.dataStorageService.setUIText(key, value);
  }

  getDesc() {
    return this.dataStorageService.filterUIText('offer.options.pf-siptrunk.desc');
  }

  getVoiceChannels() {
    return Array.from(new Set(this.pricingList.map(x => x.voiceChannels)));
  }

  setValue(event: any, field: string, value, index) {
    const data = this.dataStorageService.currentState.sipTrunks[index];

    switch (field) {
      case 'voice_channel':
        data.voiceChannels = Number(value);
        data.costMonthly = 0;
        data.costUnique = 0;
        break;
    }
    this.api.putSipTrunk(this.dataStorageService.currentState.offerID, data).then(res => {
      //debugger
      this.dataStorageService.currentState.sipTrunks[index] = res
    })
  }

  addSipTrunk()
  {
    this.api.putSipTrunk(this.dataStorageService.currentState.offerID, SipTrunk.fromPriceList(this.pricingList[0])).then(response => {
      this.dataStorageService.currentState.sipTrunks.push(response)
    })
  }

  removeSipTrunk(index)
  {
    var trunk = this.dataStorageService.currentState.sipTrunks[index]
    this.api.deleteSipTrunk(this.dataStorageService.currentState.offerID, trunk.id).then(res => {
      this.dataStorageService.currentState.sipTrunks.splice(index, 1)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/peoplephone-siptrunk/peoplephone-siptrunk.component.ts